(function () {
  'use strict';
  const configNode = document.getElementById('strayzy-shopify-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const root = config.root || '/';
  let pending = false;
  // Store the untouched print bytes in a ZIP so Shopify cannot negotiate WebP.
  function printArchive(bytes, filename) {
    const name = new TextEncoder().encode(filename);
    let crc = 0xffffffff;
    for (const byte of bytes) {
      crc ^= byte;
      for (let bit = 0; bit < 8; bit++) crc = (crc >>> 1) ^ ((crc & 1) ? 0xedb88320 : 0);
    }
    crc = (crc ^ 0xffffffff) >>> 0;
    const local = new Uint8Array(30 + name.length);
    const lv = new DataView(local.buffer);
    lv.setUint32(0, 0x04034b50, true); lv.setUint16(4, 20, true);
    lv.setUint16(6, 0x800, true); lv.setUint16(12, 33, true);
    lv.setUint32(14, crc, true); lv.setUint32(18, bytes.length, true); lv.setUint32(22, bytes.length, true);
    lv.setUint16(26, name.length, true); local.set(name, 30);
    const central = new Uint8Array(46 + name.length);
    const cv = new DataView(central.buffer);
    cv.setUint32(0, 0x02014b50, true); cv.setUint16(4, 20, true); cv.setUint16(6, 20, true);
    cv.setUint16(8, 0x800, true); cv.setUint16(14, 33, true);
    cv.setUint32(16, crc, true); cv.setUint32(20, bytes.length, true); cv.setUint32(24, bytes.length, true);
    cv.setUint16(28, name.length, true); central.set(name, 46);
    const end = new Uint8Array(22);
    const ev = new DataView(end.buffer);
    ev.setUint32(0, 0x06054b50, true); ev.setUint16(8, 1, true); ev.setUint16(10, 1, true);
    ev.setUint32(12, central.length, true); ev.setUint32(16, local.length + bytes.length, true);
    return new Blob([local, bytes, central, end], { type: 'application/zip' });
  }
  async function thumbnail(dataUrl) {
    const image = new Image();
    image.src = dataUrl;
    await image.decode();
    const canvas = document.createElement('canvas');
    canvas.width = 480;
    canvas.height = Math.round(480 * image.naturalHeight / image.naturalWidth);
    canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);
    return new Promise((resolve, reject) => canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('Nepavyko sukurti miniatiūros')), 'image/png'));
  }
  window.StrayzyShopifyCart = {
    cartUrl: root + 'cart',
    async add({ model, print, preview, design, printQuality }) {
      if (pending) throw new Error('Dizainas jau siunčiamas');
      pending = true;
      try {
        const caseType = document.querySelector('[data-shopify-cart]')?.dataset.caseType || 'Skaidrus';
        const variant = config.variants.find(item => item.model === model && item.caseType === caseType);
        if (!variant || !variant.available) throw new Error('Šio modelio šiuo metu negalima užsakyti');
        const expectedPrice = {'Skaidrus':2499, 'Skaidrus Magnetinis / MagSafe':2999}[caseType];
        if (!expectedPrice || variant.price !== expectedPrice || config.currency !== 'EUR') throw new Error('Nepavyko patvirtinti pasirinkto dėkliuko kainos');
        design.handoff.caseType = caseType;
        if (!/^data:image\/png;base64,/.test(print)) throw new Error('Trūksta spaudos PNG failo');
        if (!/^data:image\/png;base64,/.test(preview)) throw new Error('Trūksta dėkliuko miniatiūros');
        const bytes = Uint8Array.from(atob(print.split(',')[1]), char => char.charCodeAt(0));
        const form = new FormData();
        form.append('id', String(variant.id));
        form.append('quantity', '1');
        form.append('properties[_Gamybos failas ZIP]', printArchive(bytes, design.handoff.designId + '.png'), design.handoff.designId + '.zip');
        form.append('properties[_Dėkliuko peržiūra]', await thumbnail(preview), design.handoff.designId + '-preview.png');
        form.append('properties[_Dizaino duomenys]', new Blob([JSON.stringify(design)], { type: 'application/json' }), design.handoff.designId + '.json');
        form.append('properties[_Design ID]', design.handoff.designId);
        form.append('properties[_Print quality]', JSON.stringify(printQuality));
        const response = await fetch(root + 'cart/add.js', { method: 'POST', body: form, headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Shopify nepriėmė dizaino');
        // Do not report success if Shopify has failed to retain the actual file.
        const files = ['_Gamybos failas ZIP', '_Dėkliuko peržiūra', '_Dizaino duomenys'].map(key => result.properties?.[key]);
        if (files.some(file => typeof file !== 'string' || !/^(https:\/\/|\/\/|\/uploads\/)/.test(file))) {
          throw new Error('Prekė galėjo būti įdėta, tačiau spaudos failo išsaugojimas nepatvirtintas. Patikrinkite krepšelį prieš kartodami');
        }
        return result;
      } finally {
        pending = false;
      }
    }
  };
})();
